import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { ArrowRight } from "components/icons/ArrowRight";
import { getBooksGlobalStatusColor } from "constants/booksGlobalStatus";
import { Task } from "types/Models/task";
import { BooksTaskStatusModals } from "./BooksTaskStatusModals";
import { BooksTaskStatus } from "./useBooksTaskStatus";

// Tag variant used by TaskStateDropdownTag (filing page and chat header)
export const BooksTaskStatusTag = ({
  task,
  status,
}: {
  task: Task;
  status: BooksTaskStatus;
}) => (
  <div onClick={(e) => e.stopPropagation()}>
    <Dropdown.Root>
      <Dropdown.Trigger
        asChild
        disabled={status.isLoading || status.isCompleted}
      >
        <span>
          <Tag
            icon={false}
            tagType={
              status.currentOption
                ? getBooksGlobalStatusColor(status.currentOption.key)
                : "gray"
            }
            size="small"
          >
            <span className="t-flex t-items-center t-gap-1">
              {status.currentOption?.name ?? "—"}
              <div className="t-rotate-90 t-group-data-state-open:-t-rotate-90">
                <ArrowRight stroke="1.5" color="currentColor" />
              </div>
            </span>
          </Tag>
        </span>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content className="t-mt-2">
          {status.options.map((option) => (
            <Dropdown.Item
              key={option.key}
              disabled={option.isDisabled}
              onSelect={() => status.onSelect(option.key)}
              className={option.isCurrent ? "t-bg-purple-0" : undefined}
            >
              <Tag
                icon={false}
                tagType={getBooksGlobalStatusColor(option.key)}
                rounded
              >
                {option.name}
              </Tag>
            </Dropdown.Item>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
    <BooksTaskStatusModals
      task={task}
      status={status}
      isVariablePricing={false}
    />
  </div>
);
